import { render, staticRenderFns } from "./qrCode.vue?vue&type=template&id=1bafb632&"
import script from "./qrCode.vue?vue&type=script&lang=js&"
export * from "./qrCode.vue?vue&type=script&lang=js&"
import style0 from "./qrCode.vue?vue&type=style&index=0&id=1bafb632&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports